import { useContext } from "react";
import { GameContext } from "../contexts/GameContextDefinition";

/**
 * Custom hook to access the game context
 * @returns {Object} Game context with states and functions
 */
export const useGame = () => {
  const context = useContext(GameContext);
  if (!context) {
    throw new Error("useGame must be used within a GameProvider");
  }
  return context;
};
